import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function SMSIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "16"}
      height={height || "13.998"}
      viewBox="0 0 16 13.998"
    >
      <path
        id="Path_10207"
        data-name="Path 10207"
        d="M8-14.625c-4.418,0-8,2.909-8,6.5A5.744,5.744,0,0,0,1.653-4.179,7.929,7.929,0,0,1,.2-1.892a.75.75,0,0,0-.144.812A.752.752,0,0,0,.75-.627,7.582,7.582,0,0,0,5.1-2.073,9.651,9.651,0,0,0,8-1.627c4.418,0,8-2.909,8-6.5S12.417-14.625,8-14.625Zm0,11.5A8.12,8.12,0,0,1,5.549-3.5L4.84-3.729,4.23-3.3a6.72,6.72,0,0,1-1.8.906,7.837,7.837,0,0,0,.622-1.256l.331-.878-.644-.681A4.3,4.3,0,0,1,1.5-8.126c0-2.756,2.915-5,6.5-5s6.5,2.243,6.5,5S11.583-3.126,8-3.126Z"
        transform="translate(0.002 14.625)"
        fill={color || "#2f2f2f"}
      />
    </svg>
  );
}
